import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { TGRUpdateFreespinsCountsInBetBar } from "commands/tgr-update-freespins-count-in-betbar";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import { FooterComponent } from "slotworks/components/footer/footer-component";
import { RequestFreespin } from "slotworks/state-machine/standard/states/request-freespin";

export class TGRRequestFreespin extends RequestFreespin {

    public onEnter(cascadeSkip?: boolean) {
        this.skipping = cascadeSkip;

        if (this.skipping || !Services.jurisdiction.getSpinSkippingEnabled()) {
            uiFlags.set(UIFlag.NO_SKIP, true);
        }

        uiFlags.set(UIFlag.IDLE, false);
        uiFlags.set(UIFlag.AWAITING_RESPONSE, true);

        Components.get(FooterComponent)?.showFreespinStart();

        StartSpinCommand().then(() => this.resolveEnter());
    }

    protected resolveEnter(): void {
        if (!gameState.getCurrentGame().getCurrentRecord()) {
            this.error();
        } else {
            if (gameState.getCurrentGame().getRootRecord().hasMoreChildren()) {
                gameState.getCurrentGame().nextRecord();
            } else {
                gameState.getCurrentGame().getCurrentRecord().lastChild = true;
            }

            TGRUpdateFreespinsCountsInBetBar();

            if (this.skipping) {
                this.skip();
            } else {
                this.complete();
            }
        }
    }
}
